// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  word-wrap: break-word;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
/* .content-wrapper > .tween-one-leaving,
.queue-anim-leaving {
  // position: absolute !important;
  // width: 100%;
} */
.video {
  max-width: 800px;
}
#react-content {
  min-height: 100%;
}
.home-page-wrapper p {
  padding: 0;
  margin: 0;
}
/* 详细页图片或框框的样式;
*/
.home-page-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.home-page-wrapper .home-page {
  height: 100%;
  max-width: 1200px;
  position: relative;
  margin: auto;
  will-change: transform;
}
.home-page-wrapper .title-wrapper > h1,
.home-page-wrapper > h1 {
  font-size: 32px;
  color: "#red";
  margin-bottom: 16px;
}
.home-page-wrapper .title-wrapper {
  margin: 0 auto 64px;
  text-align: center;
}
.home-page {
  padding: 128px 24px;
}
@media screen and (max-width: 767px) {
  .home-page-wrapper .home-page {
    padding: 56px 24px;
  }
  .home-page-wrapper .home-page > h1 {
    font-size: 24px;
    margin: 0 auto 32px;
  }
  .home-page-wrapper .home-page > h1.title-h1 {
    margin-bottom: 8px;
  }
  .home-page-wrapper .home-page > p {
    margin-bottom: 32px;
  }
}
.header3 {
  background: #fff;
  width: 100%;
  z-index: 1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  top: 0;
}
.header3 .home-page {
  padding: 0 24px;
}
.header3-logo {
  display: inline-block;
  position: relative;
  width: 150px;
  line-height: 64px;
}
.header3-logo img {
  vertical-align: middle;
  display: inline-block;
}
.header3-logo a {
  display: block;
}
.header3-menu {
  float: right;
}
.header3-menu .ant-menu-horizontal {
  border-bottom: none;
}
.header3-menu .ant-menu {
  line-height: 62px;
  height: 64px;
  background: transparent;
}
.header3-menu .ant-menu a {
  display: block;
}
.header3-item-block {
  padding: 0 8px;
}
.header3-item-block > * {
  display: inline-block;
}
.header3-item .ant-menu-sub .ant-menu-item,
.header3-item-child .ant-menu-sub .ant-menu-item,
.header3-menu .ant-menu-sub .ant-menu-item,
.header3-item .ant-menu-inline .ant-menu-item,
.header3-item-child .ant-menu-inline .ant-menu-item,
.header3-menu .ant-menu-inline .ant-menu-item {
  height: auto;
  line-height: 1.5;
}
.header3-item .item-sub-item,
.header3-item-child .item-sub-item,
.header3-menu .item-sub-item {
  display: block;
  padding: 8px 24px;
}
.header3-item .item-image,
.header3-item-child .item-image,
.header3-menu .item-image {
  float: left;
  margin-right: 16px;
  margin-top: 4px;
  position: relative;
  z-index: 1;
}
.header3-item .item-title,
.header3-item-child .item-title,
.header3-menu .item-title {
  font-size: 14px;
  color: "#red";
  margin-left: 46px;
}
.header3-item .item-content,
.header3-item-child .item-content,
.header3-menu .item-content {
  font-size: 12px;
  margin-left: 46px;
}
@media screen and (max-width: 767px) {
  .header3-logo {
    z-index: 101;
  }
  .header3.home-page-wrapper .home-page {
    padding: 0 24px;
  }
  .header3-menu {
    height: auto;
    float: inherit;
    position: relative;
    left: -24px;
    width: calc(100% + 48px);
    opacity: 0;
    transition: opacity 0.3s "ease-in-out";
    background: #fff;
  }
  .header3-menu li {
    padding: 0 24px;
  }
  .header3-menu li.ant-menu-submenu {
    padding: 0;
  }
  .header3-menu .item-sub-item {
    padding: 8px 0;
  }
  .header3-mobile-menu {
    width: 16px;
    height: 14px;
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 100;
  }
  .header3-mobile-menu em {
    display: block;
    width: 100%;
    height: 2px;
    background: #001529;
    margin-top: 4px;
    transition: transform 0.3s "ease-in-out", opacity 0.3s "ease-in-out";
  }
  .header3-mobile-menu :first-child {
    margin-top: 0;
  }
  .header3 .ant-menu {
    height: auto;
    overflow: hidden;
  }
  .header3 .ant-menu .ant-menu-item-selected {
    border: none;
  }
  .header3 .open {
    height: auto;
  }
  .header3 .open .header3-mobile-menu em:nth-child(1) {
    transform: translateY(6px) rotate(45deg);
  }
  .header3 .open .header3-mobile-menu em:nth-child(2) {
    opacity: 0;
  }
  .header3 .open .header3-mobile-menu em:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
  }
  .header3 .open > .header3-menu {
    opacity: 1;
    pointer-events: auto;
  }
  .header3-item-block {
    height: 40px;
    line-height: 40px;
  }
}
.banner5 {
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #fdfdfd;
  background-image: linear-gradient(to top, rgba(253, 253, 253, 0.3) 0%, rgba(193, 218, 255, 0.3) 100%);
  overflow: hidden;
}
.banner5 .banner5-page {
  padding: 1px 0 0;
}
.banner5-title {
  font-size: 48px;
  line-height: 1.5;
  color: #5f9bf1;
  margin-bottom: 8px;
}
.banner5-title-wrapper {
  width: 40%;
  max-width: 450px;
  position: relative;
  top: 30%;
  left: 24px;
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
}
.banner5-explain {
  color: #333;
  font-size: 24px;
  margin-bottom: 24px;
}
.banner5-content {
  font-size: 18px;
  color: #666;
  margin-bottom: 48px;
}
.banner5-button-wrapper .banner5-button {
  background-image: linear-gradient(to right bottom, #82b5ff 0%, #3c89f6 0%);
  box-shadow: 0 8px 24px rgba(95, 155, 241, 0.35);
  border-radius: 20px;
  border: none;
  padding: 0 42px;
  line-height: 40px;
  height: 40px;
  transition: transform 0.3s, box-shadow 0.3s;
}
.banner5-button-wrapper .banner5-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 13px 24px rgba(95, 155, 241, 0.45);
  background-image: linear-gradient(to right bottom, #82b5ff 0%, #3c89f6 0%);
}
.banner5-image {
  overflow: hidden;
  width: 55%;
  max-width: 710px;
  position: absolute;
  top: 15%;
  right: 24px;
}
@media screen and (max-width: 767px) {
  .banner5 {
    min-height: 500px;
  }
  .banner5 .banner5-page.home-page {
    padding-top: 1px;
    padding-bottom: 0;
  }
  .banner5-title-wrapper {
    text-align: center;
    position: static;
    width: 100%;
    margin-top: 64px;
    left: 0;
    top: 0;
  }
  .banner5-title {
    font-size: 32px;
  }
  .banner5-explain {
    font-size: 18px;
  }
  .banner5-content {
    font-size: 14px;
  }
  .banner5-image {
    position: static;
    width: 100%;
    top: 0;
    right: 0;
    margin: 32px 0 24px;
  }
}
.content5-wrapper {
  background-color: #fafafa;
  min-height: 720px;
}
.content5-wrapper .content5 > p {
  text-align: center;
}
.content5-wrapper .content5-img-wrapper {
  margin: 0 auto;
  left: 0;
  right: 0;
}
.content5-wrapper .content5-img-wrapper .block {
  margin-bottom: 24px;
}
.content5-wrapper .content5-img-wrapper .block .content5-block-content {
  display: block;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid #e9e9e9;
  transform: translateY(0);
  transition: transform 0.3s "ease-out", box-shadow 0.3s "ease-out";
  border: none;
  color: "#red";
  transition: box-shadow 0.3s "ease-out", transform 0.3s "ease-out";
}
.content5-wrapper .content5-img-wrapper .block .content5-block-content:hover {
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-5px);
}
.content5-wrapper .content5-img-wrapper .block .content5-block-content > span {
  width: 100%;
  height: 160px;
  display: block;
  background: #e9e9e9;
  padding: 5%;
}
.content5-wrapper .content5-img-wrapper .block .content5-block-content p {
  width: 100%;
  line-height: 30px;
}
.content5-wrapper .content5-img-wrapper .block .content5-block-content:hover p {
  bottom: 0;
}
@media screen and (max-width: 767px) {
  .content5-wrapper {
    height: 2000px;
    overflow: hidden;
  }
  .content5-wrapper .content5 ul li {
    display: block;
    width: 100%;
    padding: 2%;
  }
  .content5-wrapper .content5 ul li span {
    height: 168px;
  }
  .content5-wrapper .content5 ul li p {
    position: relative;
    bottom: 0;
  }
}
.content0-wrapper {
  min-height: 446px;
  overflow: hidden;
}
.content0-wrapper .content0 {
  height: 100%;
  padding: 64px 24px;
}
.content0-wrapper .content0 > .title-wrapper {
  margin: 0 auto 48px;
}
.content0-wrapper .content0-block {
  padding: 0 4%;
  display: inline-block;
  text-align: center;
  min-height: 200px;
  margin-bottom: 24px;
}
.content0-wrapper .content0-block img {
  width: 100%;
}
.content0-wrapper .content0-block-wrapper {
  position: relative;
  height: 100%;
  top: 25%;
  padding: 20px 0;
}
.content0-wrapper .content0-block.queue-anim-leaving {
  position: relative !important;
}
.content0-wrapper .content0-block-icon {
  width: 100px;
  height: 100px;
  margin: auto;
}
.content0-wrapper .content0-block-title {
  line-height: 32px;
  margin: 10px auto;
  font-size: 24px;
}
@media screen and (max-width: 767px) {
  .content0-wrapper {
    min-height: 880px;
  }
}
.footer1-wrapper {
  background: #001529;
  overflow: hidden;
  position: relative;
  min-height: 360px;
  color: #999;
}
.footer1-wrapper .footer1 .home-page {
  padding: 64px 24px 80px;
}
.footer1-wrapper .block {
  padding: 0 32px;
}
.footer1-wrapper .block .logo {
  max-width: 180px;
}
.footer1-wrapper .block .slogan {
  font-size: 12px;
  margin-top: -20px;
}
.footer1-wrapper .block > h2 {
  margin-bottom: 24px;
  color: #ccc;
}
.footer1-wrapper .block a {
  color: #999;
  margin-bottom: 12px;
  float: left;
  clear: both;
}
.footer1-wrapper .block a:hover {
  color: 'white';
}
.footer1-wrapper .copyright-wrapper {
  width: 100%;
  border-top: 1px solid rgba(233, 233, 233, 0.1);
}
.footer1-wrapper .copyright-wrapper .home-page {
  padding: 0 24px;
  overflow: hidden;
}
.footer1-wrapper .copyright-wrapper .copyright {
  height: 80px;
  text-align: center;
  line-height: 80px;
}
@media screen and (max-width: 767px) {
  .footer1 {
    min-height: 550px;
  }
  .footer1-wrapper .footer1 .home-page {
    padding: 64px 24px 32px;
  }
  .footer1 .logo {
    margin: 0 auto 24px;
  }
  .footer1 .block {
    text-align: center;
    margin-bottom: 32px;
    padding: 0;
  }
  .footer1 > ul {
    width: 90%;
    margin: 20px auto 0;
    padding: 10px 0;
  }
  .footer1 > ul > li {
    width: 100%;
  }
  .footer1 > ul > li h2 {
    margin-bottom: 10px;
  }
  .footer1 > ul > li li {
    display: inline-block;
    margin-right: 10px;
  }
  .footer1 .copyright-wrapper .home-page {
    padding: 0;
  }
  .footer1 .copyright-wrapper .home-page .copyright {
    font-size: 12px;
  }
  .footer1 .copyright span {
    width: 90%;
  }
}
#Nav3_0.jzih1dpqqrg-editor_css {
  position: absolute;
  background-color: rgba(255, 255, 255, 0);
  box-shadow: none;
}
.ant-menu-item > .item-sub-item > .jzj81c9wabh-editor_css {
  float: none;
  margin: 4px 0px 0px;
}
.ant-menu > .ant-menu-item > .jzj8295azrs-editor_css {
  padding: 0;
}
#Feature0_0 .ant-col > .content0-block-item > .jzj8xt5kgv7-editor_css {
  font-size: 18px;
}
#Nav3_0 .home-page > .jzjgnya1gmn-editor_css {
  width: 110px;
}
#Feature0_0 .ant-col > .jzjgrrupf2c-editor_css > .content0-block-icon {
  width: 10px;
}
#Feature0_0 .ant-col > .jzjgrrupf2c-editor_css > .jzjgrlz134-editor_css {
  width: 190px;
  height: 190px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjgrlz134-editor_css {
  width: 190px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjncn210ql-editor_css {
  width: 190px;
  height: 190px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjndq0dueg-editor_css {
  width: 190px;
  height: 190px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjndsyw8sf-editor_css {
  width: 190px;
  height: 190px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjndw5oerk-editor_css {
  font-size: 18px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjne24af8c-editor_css {
  font-size: 18px;
}
#Feature0_0 .ant-col > .content0-block-item > .jzjne54fwqm-editor_css {
  font-size: 18px;
}
#Feature0_0 .ant-row > .ant-col > .jzjgrrupf2c-editor_css {
  padding: 0;
}
#Feature0_0 div > .ant-row > .content0-block {
  min-height: 340px;
  padding: 24px;
  transition: box-shadow 0.45s ease 0s;
}
#Feature0_0 div > .ant-row > .content0-block:hover {
  box-shadow: 0px 11px 56px rgba(100, 100, 136, 0.15);
}
#Footer1_0 .ant-row > .ant-col > .jzl0qcpyjra-editor_css {
  width: 100px;
}
#Footer1_0 .ant-col > div > .jzl0u1bko6-editor_css {
  margin: 16px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/LandingPage/less/common.less","webpack://./src/views/pages/LandingPage/less/antMotionStyle.less","webpack://./src/views/pages/LandingPage/less/content.less","webpack://./src/views/pages/LandingPage/less/nav3.less","webpack://./src/views/pages/LandingPage/less/banner5.less","webpack://./src/views/pages/LandingPage/less/content5.less","webpack://./src/views/pages/LandingPage/less/custom.less","webpack://./src/views/pages/LandingPage/less/feature0.less","webpack://./src/views/pages/LandingPage/less/footer1.less","webpack://./src/views/pages/LandingPage/less/edit.less"],"names":[],"mappings":"AAGA;EACE,qBAAA;ACFF;ADKA;;;;;;;;;;;;;;EAcE,SAAA;EACA,UAAA;ACHF;AACA;;;;GAIG;ADOH;EACE,gBAAA;ACLF;ADQA;EACE,gBAAA;ACNF;ADQA;EACE,UAAA;EACA,SAAA;ACNF;AACA;CACC;ACnCA;EACC,WAAA;EACA,kBAAA;EACA,gBAAA;ADqCF;ACxCC;EAKG,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;ADsCJ;AC/CC;;EAYG,eAAA;EACA,aAAA;EACA,mBAAA;ADuCJ;ACrDC;EAiBG,mBAAA;EACA,kBAAA;ADuCJ;ACnCC;EACC,mBAAA;ADqCF;AClCA;EACG;IAEG,kBAAA;EDmCJ;ECrCC;IAIK,eAAA;IACA,mBAAA;EDoCN;ECnCM;IACE,kBAAA;EDqCR;EC5CC;IAWK,mBAAA;EDoCN;AACF;AE1EC;EACC,gBAAA;EACA,WAAA;EACA,UAAA;EACA,yCAAA;EACA,kBAAA;EACA,MAAA;AF4EF;AElFC;EASG,eAAA;AF4EJ;AEzEE;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AF2EJ;AEzEI;EACE,sBAAA;EACA,qBAAA;AF2EN;AExEI;EACE,cAAA;AF0EN;AEtEE;EACE,YAAA;AFwEJ;AEzEE;EAGI,mBAAA;AFyEN;AE5EE;EAMI,iBAAA;EACA,YAAA;EACA,uBAAA;AFyEN;AEjFE;EAWM,cAAA;AFyER;AEnEI;EACE,cAAA;AFqEN;AEtEI;EAII,qBAAA;AFqER;AEhEE;;;;;;EAMI,YAAA;EACA,gBAAA;AFkEN;AE9DM;;;EACE,cAAA;EACA,iBAAA;AFkER;AE/DM;;;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AFmER;AEhEM;;;EACE,eAAA;EACA,aAAA;EACA,iBAAA;AFoER;AEjEM;;;EACE,eAAA;EACA,iBAAA;AFqER;AE/DA;EAEI;IACE,YAAA;EFgEJ;EE7DE;IACE,eAAA;EF+DJ;EE5DE;IACE,YAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,wBAAA;IACA,UAAA;IACA,sCAAA;IACA,gBAAA;EF8DJ;EE5DI;IACE,eAAA;EF8DN;EE5DM;IACE,UAAA;EF8DR;EE1DM;IACE,cAAA;EF4DR;EEvDE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;EFyDJ;EEhEE;IAUI,cAAA;IACA,WAAA;IACA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,oEAAA;EFyDN;EExEE;IAmBI,aAAA;EFwDN;EE5GC;IAyDG,YAAA;IACA,gBAAA;EFsDJ;EEhHC;IA6DK,YAAA;EFsDN;EElDE;IACE,YAAA;EFoDJ;EEhDQ;IACE,wCAAA;EFkDV;EE/CQ;IACE,UAAA;EFiDV;EE9CQ;IACE,0CAAA;EFgDV;EE9DE;IAoBI,UAAA;IACA,oBAAA;EF6CN;EE1CE;IACE,YAAA;IACA,iBAAA;EF4CJ;AACF;AGrOC;EAEC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,qGAAA;EACA,gBAAA;AHsOF;AGpOE;EACE,gBAAA;AHsOJ;AGnOE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AHqOJ;AGnOI;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,0NAAA;AHqON;AGjOE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AHmOJ;AGhOE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AHkOJ;AG/NE;EAEI,0EAAA;EACA,+CAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,2CAAA;AHgON;AG/NM;EACE,2BAAA;EACA,gDAAA;EACA,0EAAA;AHiOR;AG5NE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AH8NJ;AG1NA;EACG;IACC,iBAAA;EH4NF;EG1NE;IACE,gBAAA;IACA,iBAAA;EH4NJ;EGzNE;IACE,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,OAAA;IACA,MAAA;EH2NJ;EGxNE;IACE,eAAA;EH0NJ;EGvNE;IACE,eAAA;EHyNJ;EGtNE;IACE,eAAA;EHwNJ;EGrNE;IACE,gBAAA;IACA,WAAA;IACA,MAAA;IACA,QAAA;IACA,mBAAA;EHuNJ;AACF;AIjUC;EACC,yBAAA;EACA,iBAAA;AJmUF;AIrUC;EAKK,kBAAA;AJmUN;AIjUI;EACE,cAAA;EACA,OAAA;EACA,QAAA;AJmUN;AItUI;EAKI,mBAAA;AJoUR;AIzUI;EAOM,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ECKR,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,iEAAA;EDNQ,YAAA;EACA,aAAA;EACA,iEAAA;AJwUV;AKnUE;EARA,yCAAA;EAUE,2BAAA;ALqUJ;AI3UU;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AJ6UZ;AI3UU;EACE,WAAA;EACA,iBAAA;AJ6UZ;AI1UY;EACE,SAAA;AJ4Ud;AInUA;EACG;IACC,cAAA;IACA,gBAAA;EJqUF;EIvUC;IAMO,cAAA;IACA,WAAA;IACA,WAAA;EJoUR;EI5UC;IAUS,aAAA;EJqUV;EI/UC;IAaS,kBAAA;IACA,SAAA;EJqUV;AACF;AMnYC;EACC,iBAAA;EACA,gBAAA;ANqYF;AMvYC;EAKG,YAAA;EACA,kBAAA;ANqYJ;AM3YC;EASK,mBAAA;ANqYN;AMlYI;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;ANoYN;AMzYI;EAOI,WAAA;ANqYR;AMlYM;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;ANoYR;AMjYM;EACE,6BAAA;ANmYR;AMhYM;EACE,YAAA;EACA,aAAA;EACA,YAAA;ANkYR;AM/XM;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;ANiYR;AM3XA;EACG;IACC,iBAAA;EN6XF;AACF;AOlbA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;APobF;AOzbA;EAQM,uBAAA;APobN;AO5bA;EAYI,eAAA;APmbJ;AO/bA;EAcM,gBAAA;APobN;AOlcA;EAiBM,eAAA;EACA,iBAAA;APobN;AOtcA;EAqBM,mBAAA;EACA,WAAA;APobN;AO1cA;EAyBM,WAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;APobN;AOnbM;EACE,cAAA;APqbR;AOndA;EAmCI,WAAA;EACA,8CAAA;APmbJ;AOvdA;EAsCM,eAAA;EACA,gBAAA;APobN;AO3dA;EA0CM,YAAA;EACA,kBAAA;EACA,iBAAA;APobN;AO/aA;EACE;IACE,iBAAA;EPibF;EOhbE;IAGM,uBAAA;EPgbR;EOrbA;IAUI,mBAAA;EP8aJ;EOxbA;IAaI,kBAAA;IACA,mBAAA;IACA,UAAA;EP8aJ;EO7bA;IAkBI,UAAA;IACA,mBAAA;IACA,eAAA;EP8aJ;EOlcA;IAsBM,WAAA;EP+aN;EOrcA;IAwBQ,mBAAA;EPgbR;EOxcA;IA2BQ,qBAAA;IACA,kBAAA;EPgbR;EO3aI;IAEI,UAAA;EP4aR;EO9aI;IAIM,eAAA;EP6aV;EOldA;IA2CM,UAAA;EP0aN;AACF;AQxgBA;EACE,kBAAA;EACA,wCAAA;EACA,gBAAA;AR0gBF;AQxgBA;EACE,WAAA;EACA,mBAAA;AR0gBF;AQxgBA;EACE,UAAA;AR0gBF;AQxgBA;EACE,eAAA;AR0gBF;AQxgBA;EACE,YAAA;AR0gBF;AQtgBA;EACE,WAAA;ARwgBF;AQtgBA;EACE,YAAA;EACA,aAAA;ARwgBF;AQtgBA;EACE,YAAA;ARwgBF;AQtgBA;EACE,YAAA;EACA,aAAA;ARwgBF;AQtgBA;EACE,YAAA;EACA,aAAA;ARwgBF;AQtgBA;EACE,YAAA;EACA,aAAA;ARwgBF;AQtgBA;EACE,eAAA;ARwgBF;AQtgBA;EACE,eAAA;ARwgBF;AQtgBA;EACE,eAAA;ARwgBF;AQtgBA;EACE,UAAA;ARwgBF;AQrgBA;EACE,iBAAA;EACA,aAAA;EACA,oCAAA;ARugBF;AQrgBA;EACE,mDAAA;ARugBF;AQrgBA;EACE,YAAA;ARugBF;AQrgBA;EACE,gBAAA;ARugBF","sourcesContent":["\n// @import \"~antd/lib/style/v2-compatible-reset.less\";\n\nbody {\n  word-wrap: break-word;\n}\n\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n\n.video {\n  max-width: 800px;\n}\n\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n\n@text-color: \"#red\";\n@ease-in-out: \"ease-in-out\";\n@ease-out: \"ease-out\";\n@primary-color: 'white';\n","body {\n  word-wrap: break-word;\n}\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n.video {\n  max-width: 800px;\n}\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n/* 详细页图片或框框的样式;\n*/\n.home-page-wrapper {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.home-page-wrapper .home-page {\n  height: 100%;\n  max-width: 1200px;\n  position: relative;\n  margin: auto;\n  will-change: transform;\n}\n.home-page-wrapper .title-wrapper > h1,\n.home-page-wrapper > h1 {\n  font-size: 32px;\n  color: \"#red\";\n  margin-bottom: 16px;\n}\n.home-page-wrapper .title-wrapper {\n  margin: 0 auto 64px;\n  text-align: center;\n}\n.home-page {\n  padding: 128px 24px;\n}\n@media screen and (max-width: 767px) {\n  .home-page-wrapper .home-page {\n    padding: 56px 24px;\n  }\n  .home-page-wrapper .home-page > h1 {\n    font-size: 24px;\n    margin: 0 auto 32px;\n  }\n  .home-page-wrapper .home-page > h1.title-h1 {\n    margin-bottom: 8px;\n  }\n  .home-page-wrapper .home-page > p {\n    margin-bottom: 32px;\n  }\n}\n.header3 {\n  background: #fff;\n  width: 100%;\n  z-index: 1;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  position: relative;\n  top: 0;\n}\n.header3 .home-page {\n  padding: 0 24px;\n}\n.header3-logo {\n  display: inline-block;\n  position: relative;\n  width: 150px;\n  line-height: 64px;\n}\n.header3-logo img {\n  vertical-align: middle;\n  display: inline-block;\n}\n.header3-logo a {\n  display: block;\n}\n.header3-menu {\n  float: right;\n}\n.header3-menu .ant-menu-horizontal {\n  border-bottom: none;\n}\n.header3-menu .ant-menu {\n  line-height: 62px;\n  height: 64px;\n  background: transparent;\n}\n.header3-menu .ant-menu a {\n  display: block;\n}\n.header3-item-block {\n  padding: 0 8px;\n}\n.header3-item-block > * {\n  display: inline-block;\n}\n.header3-item .ant-menu-sub .ant-menu-item,\n.header3-item-child .ant-menu-sub .ant-menu-item,\n.header3-menu .ant-menu-sub .ant-menu-item,\n.header3-item .ant-menu-inline .ant-menu-item,\n.header3-item-child .ant-menu-inline .ant-menu-item,\n.header3-menu .ant-menu-inline .ant-menu-item {\n  height: auto;\n  line-height: 1.5;\n}\n.header3-item .item-sub-item,\n.header3-item-child .item-sub-item,\n.header3-menu .item-sub-item {\n  display: block;\n  padding: 8px 24px;\n}\n.header3-item .item-image,\n.header3-item-child .item-image,\n.header3-menu .item-image {\n  float: left;\n  margin-right: 16px;\n  margin-top: 4px;\n  position: relative;\n  z-index: 1;\n}\n.header3-item .item-title,\n.header3-item-child .item-title,\n.header3-menu .item-title {\n  font-size: 14px;\n  color: \"#red\";\n  margin-left: 46px;\n}\n.header3-item .item-content,\n.header3-item-child .item-content,\n.header3-menu .item-content {\n  font-size: 12px;\n  margin-left: 46px;\n}\n@media screen and (max-width: 767px) {\n  .header3-logo {\n    z-index: 101;\n  }\n  .header3.home-page-wrapper .home-page {\n    padding: 0 24px;\n  }\n  .header3-menu {\n    height: auto;\n    float: inherit;\n    position: relative;\n    left: -24px;\n    width: calc(100% + 48px);\n    opacity: 0;\n    transition: opacity 0.3s \"ease-in-out\";\n    background: #fff;\n  }\n  .header3-menu li {\n    padding: 0 24px;\n  }\n  .header3-menu li.ant-menu-submenu {\n    padding: 0;\n  }\n  .header3-menu .item-sub-item {\n    padding: 8px 0;\n  }\n  .header3-mobile-menu {\n    width: 16px;\n    height: 14px;\n    cursor: pointer;\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    z-index: 100;\n  }\n  .header3-mobile-menu em {\n    display: block;\n    width: 100%;\n    height: 2px;\n    background: #001529;\n    margin-top: 4px;\n    transition: transform 0.3s \"ease-in-out\", opacity 0.3s \"ease-in-out\";\n  }\n  .header3-mobile-menu :first-child {\n    margin-top: 0;\n  }\n  .header3 .ant-menu {\n    height: auto;\n    overflow: hidden;\n  }\n  .header3 .ant-menu .ant-menu-item-selected {\n    border: none;\n  }\n  .header3 .open {\n    height: auto;\n  }\n  .header3 .open .header3-mobile-menu em:nth-child(1) {\n    transform: translateY(6px) rotate(45deg);\n  }\n  .header3 .open .header3-mobile-menu em:nth-child(2) {\n    opacity: 0;\n  }\n  .header3 .open .header3-mobile-menu em:nth-child(3) {\n    transform: translateY(-6px) rotate(-45deg);\n  }\n  .header3 .open > .header3-menu {\n    opacity: 1;\n    pointer-events: auto;\n  }\n  .header3-item-block {\n    height: 40px;\n    line-height: 40px;\n  }\n}\n.banner5 {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  background-color: #fdfdfd;\n  background-image: linear-gradient(to top, rgba(253, 253, 253, 0.3) 0%, rgba(193, 218, 255, 0.3) 100%);\n  overflow: hidden;\n}\n.banner5 .banner5-page {\n  padding: 1px 0 0;\n}\n.banner5-title {\n  font-size: 48px;\n  line-height: 1.5;\n  color: #5f9bf1;\n  margin-bottom: 8px;\n}\n.banner5-title-wrapper {\n  width: 40%;\n  max-width: 450px;\n  position: relative;\n  top: 30%;\n  left: 24px;\n  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n}\n.banner5-explain {\n  color: #333;\n  font-size: 24px;\n  margin-bottom: 24px;\n}\n.banner5-content {\n  font-size: 18px;\n  color: #666;\n  margin-bottom: 48px;\n}\n.banner5-button-wrapper .banner5-button {\n  background-image: linear-gradient(to right bottom, #82b5ff 0%, #3c89f6 0%);\n  box-shadow: 0 8px 24px rgba(95, 155, 241, 0.35);\n  border-radius: 20px;\n  border: none;\n  padding: 0 42px;\n  line-height: 40px;\n  height: 40px;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n.banner5-button-wrapper .banner5-button:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 13px 24px rgba(95, 155, 241, 0.45);\n  background-image: linear-gradient(to right bottom, #82b5ff 0%, #3c89f6 0%);\n}\n.banner5-image {\n  overflow: hidden;\n  width: 55%;\n  max-width: 710px;\n  position: absolute;\n  top: 15%;\n  right: 24px;\n}\n@media screen and (max-width: 767px) {\n  .banner5 {\n    min-height: 500px;\n  }\n  .banner5 .banner5-page.home-page {\n    padding-top: 1px;\n    padding-bottom: 0;\n  }\n  .banner5-title-wrapper {\n    text-align: center;\n    position: static;\n    width: 100%;\n    margin-top: 64px;\n    left: 0;\n    top: 0;\n  }\n  .banner5-title {\n    font-size: 32px;\n  }\n  .banner5-explain {\n    font-size: 18px;\n  }\n  .banner5-content {\n    font-size: 14px;\n  }\n  .banner5-image {\n    position: static;\n    width: 100%;\n    top: 0;\n    right: 0;\n    margin: 32px 0 24px;\n  }\n}\n.content5-wrapper {\n  background-color: #fafafa;\n  min-height: 720px;\n}\n.content5-wrapper .content5 > p {\n  text-align: center;\n}\n.content5-wrapper .content5-img-wrapper {\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n}\n.content5-wrapper .content5-img-wrapper .block {\n  margin-bottom: 24px;\n}\n.content5-wrapper .content5-img-wrapper .block .content5-block-content {\n  display: block;\n  background: #fff;\n  border-radius: 4px;\n  padding: 10px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border-radius: 6px;\n  border: 1px solid #e9e9e9;\n  transform: translateY(0);\n  transition: transform 0.3s \"ease-out\", box-shadow 0.3s \"ease-out\";\n  border: none;\n  color: \"#red\";\n  transition: box-shadow 0.3s \"ease-out\", transform 0.3s \"ease-out\";\n}\n.content5-wrapper .content5-img-wrapper .block .content5-block-content:hover {\n  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-5px);\n}\n.content5-wrapper .content5-img-wrapper .block .content5-block-content > span {\n  width: 100%;\n  height: 160px;\n  display: block;\n  background: #e9e9e9;\n  padding: 5%;\n}\n.content5-wrapper .content5-img-wrapper .block .content5-block-content p {\n  width: 100%;\n  line-height: 30px;\n}\n.content5-wrapper .content5-img-wrapper .block .content5-block-content:hover p {\n  bottom: 0;\n}\n@media screen and (max-width: 767px) {\n  .content5-wrapper {\n    height: 2000px;\n    overflow: hidden;\n  }\n  .content5-wrapper .content5 ul li {\n    display: block;\n    width: 100%;\n    padding: 2%;\n  }\n  .content5-wrapper .content5 ul li span {\n    height: 168px;\n  }\n  .content5-wrapper .content5 ul li p {\n    position: relative;\n    bottom: 0;\n  }\n}\n.content0-wrapper {\n  min-height: 446px;\n  overflow: hidden;\n}\n.content0-wrapper .content0 {\n  height: 100%;\n  padding: 64px 24px;\n}\n.content0-wrapper .content0 > .title-wrapper {\n  margin: 0 auto 48px;\n}\n.content0-wrapper .content0-block {\n  padding: 0 4%;\n  display: inline-block;\n  text-align: center;\n  min-height: 200px;\n  margin-bottom: 24px;\n}\n.content0-wrapper .content0-block img {\n  width: 100%;\n}\n.content0-wrapper .content0-block-wrapper {\n  position: relative;\n  height: 100%;\n  top: 25%;\n  padding: 20px 0;\n}\n.content0-wrapper .content0-block.queue-anim-leaving {\n  position: relative !important;\n}\n.content0-wrapper .content0-block-icon {\n  width: 100px;\n  height: 100px;\n  margin: auto;\n}\n.content0-wrapper .content0-block-title {\n  line-height: 32px;\n  margin: 10px auto;\n  font-size: 24px;\n}\n@media screen and (max-width: 767px) {\n  .content0-wrapper {\n    min-height: 880px;\n  }\n}\n.footer1-wrapper {\n  background: #001529;\n  overflow: hidden;\n  position: relative;\n  min-height: 360px;\n  color: #999;\n}\n.footer1-wrapper .footer1 .home-page {\n  padding: 64px 24px 80px;\n}\n.footer1-wrapper .block {\n  padding: 0 32px;\n}\n.footer1-wrapper .block .logo {\n  max-width: 180px;\n}\n.footer1-wrapper .block .slogan {\n  font-size: 12px;\n  margin-top: -20px;\n}\n.footer1-wrapper .block > h2 {\n  margin-bottom: 24px;\n  color: #ccc;\n}\n.footer1-wrapper .block a {\n  color: #999;\n  margin-bottom: 12px;\n  float: left;\n  clear: both;\n}\n.footer1-wrapper .block a:hover {\n  color: 'white';\n}\n.footer1-wrapper .copyright-wrapper {\n  width: 100%;\n  border-top: 1px solid rgba(233, 233, 233, 0.1);\n}\n.footer1-wrapper .copyright-wrapper .home-page {\n  padding: 0 24px;\n  overflow: hidden;\n}\n.footer1-wrapper .copyright-wrapper .copyright {\n  height: 80px;\n  text-align: center;\n  line-height: 80px;\n}\n@media screen and (max-width: 767px) {\n  .footer1 {\n    min-height: 550px;\n  }\n  .footer1-wrapper .footer1 .home-page {\n    padding: 64px 24px 32px;\n  }\n  .footer1 .logo {\n    margin: 0 auto 24px;\n  }\n  .footer1 .block {\n    text-align: center;\n    margin-bottom: 32px;\n    padding: 0;\n  }\n  .footer1 > ul {\n    width: 90%;\n    margin: 20px auto 0;\n    padding: 10px 0;\n  }\n  .footer1 > ul > li {\n    width: 100%;\n  }\n  .footer1 > ul > li h2 {\n    margin-bottom: 10px;\n  }\n  .footer1 > ul > li li {\n    display: inline-block;\n    margin-right: 10px;\n  }\n  .footer1 .copyright-wrapper .home-page {\n    padding: 0;\n  }\n  .footer1 .copyright-wrapper .home-page .copyright {\n    font-size: 12px;\n  }\n  .footer1 .copyright span {\n    width: 90%;\n  }\n}\n#Nav3_0.jzih1dpqqrg-editor_css {\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0);\n  box-shadow: none;\n}\n.ant-menu-item > .item-sub-item > .jzj81c9wabh-editor_css {\n  float: none;\n  margin: 4px 0px 0px;\n}\n.ant-menu > .ant-menu-item > .jzj8295azrs-editor_css {\n  padding: 0;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzj8xt5kgv7-editor_css {\n  font-size: 18px;\n}\n#Nav3_0 .home-page > .jzjgnya1gmn-editor_css {\n  width: 110px;\n}\n#Feature0_0 .ant-col > .jzjgrrupf2c-editor_css > .content0-block-icon {\n  width: 10px;\n}\n#Feature0_0 .ant-col > .jzjgrrupf2c-editor_css > .jzjgrlz134-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjgrlz134-editor_css {\n  width: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjncn210ql-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjndq0dueg-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjndsyw8sf-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjndw5oerk-editor_css {\n  font-size: 18px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjne24af8c-editor_css {\n  font-size: 18px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjne54fwqm-editor_css {\n  font-size: 18px;\n}\n#Feature0_0 .ant-row > .ant-col > .jzjgrrupf2c-editor_css {\n  padding: 0;\n}\n#Feature0_0 div > .ant-row > .content0-block {\n  min-height: 340px;\n  padding: 24px;\n  transition: box-shadow 0.45s ease 0s;\n}\n#Feature0_0 div > .ant-row > .content0-block:hover {\n  box-shadow: 0px 11px 56px rgba(100, 100, 136, 0.15);\n}\n#Footer1_0 .ant-row > .ant-col > .jzl0qcpyjra-editor_css {\n  width: 100px;\n}\n#Footer1_0 .ant-col > div > .jzl0u1bko6-editor_css {\n  margin: 16px 0 0;\n}\n","@homepage: home-page;\n.@{homepage}-wrapper {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  .@{homepage} {\n    height: 100%;\n    max-width: 1200px;\n    position: relative;\n    margin: auto;\n    will-change: transform;\n  }\n  .title-wrapper > h1, > h1 {\n    font-size: 32px;\n    color: @text-color;\n    margin-bottom: 16px;\n  }\n  .title-wrapper {\n    margin: 0 auto 64px;\n    text-align: center;\n  }\n}\n\n.@{homepage} {\n  padding: 128px 24px;\n}\n\n@media screen and (max-width: 767px) {\n  .@{homepage}-wrapper {\n    .@{homepage} {\n      padding: 56px 24px;\n      >h1 {\n        font-size: 24px;\n        margin: 0 auto 32px;\n        &.title-h1 {\n          margin-bottom: 8px;\n        }\n      }\n      >p {\n        margin-bottom: 32px;\n      }\n    }\n  }\n}\n","@header3: header3;\n\n.@{header3} {\n  background: #fff;\n  width: 100%;\n  z-index: 1;\n  box-shadow: 0 4px 6px fade(#000, 5);\n  position: relative;\n  top: 0;\n\n  .home-page {\n    padding: 0 24px;\n  }\n\n  &-logo {\n    display: inline-block;\n    position: relative;\n    width: 150px;\n    line-height: 64px;\n\n    & img {\n      vertical-align: middle;\n      display: inline-block;\n    }\n\n    & a {\n      display: block;\n    }\n  }\n\n  &-menu {\n    float: right;\n    .ant-menu-horizontal {\n      border-bottom: none;\n    }\n    .ant-menu {\n      line-height: 62px;\n      height: 64px;\n      background: transparent;\n\n      a {\n        display: block;\n      }\n    }\n  }\n\n  &-item {\n    &-block {\n      padding: 0 8px;\n\n      >* {\n        display: inline-block;\n      }\n    }\n  }\n\n  &-item,\n  &-item-child,\n  &-menu {\n\n    .ant-menu-sub .ant-menu-item,\n    .ant-menu-inline .ant-menu-item {\n      height: auto;\n      line-height: 1.5;\n    }\n\n    .item {\n      &-sub-item {\n        display: block;\n        padding: 8px 24px;\n      }\n\n      &-image {\n        float: left;\n        margin-right: 16px;\n        margin-top: 4px;\n        position: relative;\n        z-index: 1;\n      }\n\n      &-title {\n        font-size: 14px;\n        color: @text-color;\n        margin-left: 46px;\n      }\n\n      &-content {\n        font-size: 12px;\n        margin-left: 46px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{header3} {\n    &-logo {\n      z-index: 101;\n    }\n\n    &.home-page-wrapper .home-page {\n      padding: 0 24px;\n    }\n\n    &-menu {\n      height: auto;\n      float: inherit;\n      position: relative;\n      left: -24px;\n      width: ~\"calc(100% + 48px)\";\n      opacity: 0;\n      transition: opacity .3s @ease-in-out;\n      background: #fff;\n\n      & li {\n        padding: 0 24px;\n\n        &.ant-menu-submenu {\n          padding: 0;\n        }\n      }\n      .item {\n        &-sub-item {\n          padding: 8px 0;\n        }\n      }\n    }\n\n    &-mobile-menu {\n      width: 16px;\n      height: 14px;\n      cursor: pointer;\n      position: absolute;\n      top: 24px;\n      right: 24px;\n      z-index: 100;\n\n      em {\n        display: block;\n        width: 100%;\n        height: 2px;\n        background: @template-nav-bg-color;\n        margin-top: 4px;\n        transition: transform .3s @ease-in-out, opacity .3s @ease-in-out;\n      }\n\n      :first-child {\n        margin-top: 0;\n      }\n    }\n\n    .ant-menu {\n      height: auto;\n      overflow: hidden;\n\n      .ant-menu-item-selected {\n        border: none;\n      }\n    }\n\n    & .open {\n      height: auto;\n\n      .@{header3}-mobile-menu {\n        em {\n          &:nth-child(1) {\n            transform: translateY(6px) rotate(45deg);\n          }\n\n          &:nth-child(2) {\n            opacity: 0;\n          }\n\n          &:nth-child(3) {\n            transform: translateY(-6px) rotate(-45deg);\n          }\n        }\n      }\n\n      >.@{header3}-menu {\n        opacity: 1;\n        pointer-events: auto;\n      }\n    }\n    &-item-block {\n      height: 40px;\n      line-height: 40px;\n    }\n  }\n}\n","@banner5: banner5;\n\n.@{banner5} {\n  // 如果在第一屏且导航位置为 relative, 一屏为 height: calc(~\"100vh - 64px\");\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  background-color: #fdfdfd;\n  background-image: linear-gradient(to top, fade(#fdfdfd, 30) 0%, fade(#c1daff, 30) 100%);\n  overflow: hidden;\n\n  & &-page {\n    padding: 1px 0 0;\n  }\n\n  &-title {\n    font-size: 48px;\n    line-height: 1.5;\n    color: #5f9bf1;\n    margin-bottom: 8px;\n\n    &-wrapper {\n      width: 40%;\n      max-width: 450px;\n      position: relative;\n      top: 30%;\n      left: 24px;\n      font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n    }\n  }\n\n  &-explain {\n    color: #333;\n    font-size: 24px;\n    margin-bottom: 24px;\n  }\n\n  &-content {\n    font-size: 18px;\n    color: #666;\n    margin-bottom: 48px;\n  }\n\n  &-button-wrapper {\n    .@{banner5}-button {\n      background-image: linear-gradient(to right bottom, #82b5ff 0%, #3c89f6 0%);\n      box-shadow: 0 8px 24px fade(#5f9bf1, 35);\n      border-radius: 20px;\n      border: none;\n      padding: 0 42px;\n      line-height: 40px;\n      height: 40px;\n      transition: transform .3s, box-shadow .3s;\n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 13px 24px fade(#5f9bf1, 45);\n        background-image: linear-gradient(to right bottom, #82b5ff 0%, #3c89f6 0%);\n      }\n    }\n  }\n\n  &-image {\n    overflow: hidden;\n    width: 55%;\n    max-width: 710px;\n    position: absolute;\n    top: 15%;\n    right: 24px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{banner5} {\n    min-height: 500px;\n\n    & &-page.home-page {\n      padding-top: 1px;\n      padding-bottom: 0;\n    }\n\n    &-title-wrapper {\n      text-align: center;\n      position: static;\n      width: 100%;\n      margin-top: 64px;\n      left: 0;\n      top: 0;\n    }\n\n    &-title {\n      font-size: 32px;\n    }\n\n    &-explain {\n      font-size: 18px;\n    }\n\n    &-content {\n      font-size: 14px;\n    }\n\n    &-image {\n      position: static;\n      width: 100%;\n      top: 0;\n      right: 0;\n      margin: 32px 0 24px;\n    }\n  }\n}\n","@content5: content5;\n.@{content5}-wrapper {\n  background-color: #fafafa;\n  min-height: 720px;\n  .@{content5} {\n    >p {\n      text-align: center;\n    }\n    &-img-wrapper {\n      margin: 0 auto;\n      left: 0;\n      right: 0;\n      .block {\n        margin-bottom: 24px;\n        .content5-block-content {\n          display: block;\n          background: #fff;\n          border-radius: 4px;\n          padding: 10px;\n          text-align: center;\n          position: relative;\n          overflow: hidden;\n          .page-pro();\n          border: none;\n          color: @text-color;\n          transition: box-shadow .3s @ease-out, transform .3s @ease-out;\n          & > span {\n            width: 100%;\n            height: 160px;\n            display: block;\n            background: @line-color;\n            padding: 5%;\n          }\n          & p {\n            width: 100%;\n            line-height: 30px;\n          }\n          &:hover {\n            & p {\n              bottom: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{content5}-wrapper {\n    height: 2000px;\n    overflow: hidden;\n    .@{content5} {\n      ul {\n        li {\n          display: block;\n          width: 100%;\n          padding: 2%;\n          span {\n            height: 168px;\n          }\n          p {\n            position: relative;\n            bottom: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","// @import \"~antd/lib/style/themes/default.less\";\n\n@line-color: #e9e9e9;\n\n@shadow-color: rgba(0, 0, 0, 0.15);\n\n@bottom-bar-bg-color: #262626;\n@bottom-bar-line-color: #000;\n\n@template-bg-color: #001529;\n@template-bg-color-light: #ececec;\n@template-nav-bg-color: #001529;\n@template-text-color: #ccc;\n@template-text-title-color: #bcbcbc;\n@template-text-color-light: #fff;\n@template-footer-text-color: #999;\n\n@animate-duration: .45s;\n\n/* 详细页图片或框框的样式;\n*/\n.page-shadow() {\n  box-shadow: 0 5px 8px @shadow-color;\n}\n\n.page-pro() {\n  border-radius: 6px;\n  border: 1px solid @line-color;\n  transform: translateY(0);\n  transition: transform .3s @ease-out, box-shadow .3s @ease-out;\n  &:hover {\n    .page-shadow();\n    transform: translateY(-5px);\n  }\n}\n","@content0: content0;\n\n.@{content0}-wrapper {\n  min-height: 446px;\n  overflow: hidden;\n\n  .@{content0} {\n    height: 100%;\n    padding: 64px 24px;\n\n    >.title-wrapper {\n      margin: 0 auto 48px;\n    }\n\n    &-block {\n      padding: 0 4%;\n      display: inline-block;\n      text-align: center;\n      min-height: 200px;\n      margin-bottom: 24px;\n      img {\n        width: 100%;\n      }\n\n      &-wrapper {\n        position: relative;\n        height: 100%;\n        top: 25%;\n        padding: 20px 0;\n      }\n\n      &.queue-anim-leaving {\n        position: relative !important;\n      }\n\n      &-icon {\n        width: 100px;\n        height: 100px;\n        margin: auto;\n      }\n\n      &-title {\n        line-height: 32px;\n        margin: 10px auto;\n        font-size: 24px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{content0}-wrapper {\n    min-height: 880px;\n  }\n}\n",".footer1-wrapper {\n  background: @template-bg-color;\n  overflow: hidden;\n  position: relative;\n  min-height: 360px;\n  color: @template-footer-text-color;\n  .footer1 {\n    .home-page {\n      padding: 64px 24px 80px;\n    }\n  }\n  .block {\n    padding: 0 32px;\n    .logo {\n      max-width: 180px;\n    }\n    .slogan {\n      font-size: 12px;\n      margin-top: -20px;\n    }\n    >h2 {\n      margin-bottom: 24px;\n      color: @template-text-color;\n    }\n    a {\n      color: @template-footer-text-color;\n      margin-bottom: 12px;\n      float: left;\n      clear: both;\n      &:hover {\n        color: @primary-color;\n      }\n    }\n  }\n  .copyright-wrapper {\n    width: 100%;\n    border-top: 1px solid fade(@line-color, 10);\n    .home-page {\n      padding: 0 24px;\n      overflow: hidden;\n    }\n    .copyright {\n      height: 80px;\n      text-align: center;\n      line-height: 80px;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .footer1 {\n    min-height: 550px;\n    &-wrapper {\n      .footer1 {\n        .home-page {\n          padding: 64px 24px 32px;\n        }\n      }\n    }\n    .logo {\n      margin: 0 auto 24px;\n    }\n    .block {\n      text-align: center;\n      margin-bottom: 32px;\n      padding: 0;\n    }\n    >ul {\n      width: 90%;\n      margin: 20px auto 0;\n      padding: 10px 0;\n      >li {\n        width: 100%;\n        h2 {\n          margin-bottom: 10px;\n        }\n        li {\n          display: inline-block;\n          margin-right: 10px;\n        }\n      }\n    }\n    .copyright {\n      &-wrapper {\n        .home-page {\n          padding: 0;\n          .copyright {\n            font-size: 12px;\n          }\n        }\n      }\n\n      span {\n        width: 90%;\n      }\n    }\n  }\n}\n","#Nav3_0.jzih1dpqqrg-editor_css {\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0);\n  box-shadow: none;\n}\n.ant-menu-item > .item-sub-item > .jzj81c9wabh-editor_css {\n  float: none;\n  margin: 4px 0px 0px;\n}\n.ant-menu > .ant-menu-item > .jzj8295azrs-editor_css {\n  padding: 0;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzj8xt5kgv7-editor_css {\n  font-size: 18px;\n}\n#Nav3_0 .home-page > .jzjgnya1gmn-editor_css {\n  width: 110px;\n}\n#Feature0_0 .ant-row > .ant-col > .content0-block-item {\n}\n#Feature0_0 .ant-col > .jzjgrrupf2c-editor_css > .content0-block-icon {\n  width: 10px;\n}\n#Feature0_0 .ant-col > .jzjgrrupf2c-editor_css > .jzjgrlz134-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjgrlz134-editor_css {\n  width: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjncn210ql-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjndq0dueg-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjndsyw8sf-editor_css {\n  width: 190px;\n  height: 190px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjndw5oerk-editor_css {\n  font-size: 18px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjne24af8c-editor_css {\n  font-size: 18px;\n}\n#Feature0_0 .ant-col > .content0-block-item > .jzjne54fwqm-editor_css {\n  font-size: 18px;\n}\n#Feature0_0 .ant-row > .ant-col > .jzjgrrupf2c-editor_css {\n  padding: 0;\n}\n\n#Feature0_0 div > .ant-row > .content0-block {\n  min-height: 340px;\n  padding: 24px;\n  transition: box-shadow 0.45s ease 0s;\n}\n#Feature0_0 div > .ant-row > .content0-block:hover {\n  box-shadow: 0px 11px 56px rgba(100, 100, 136, 0.15);\n}\n#Footer1_0 .ant-row > .ant-col > .jzl0qcpyjra-editor_css {\n  width: 100px;\n}\n#Footer1_0 .ant-col > div > .jzl0u1bko6-editor_css {\n  margin: 16px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
